import React, { useEffect } from 'react';
import { Button, Form, Select } from 'antd';
import { useAuth } from '@isocel/front-common';
import { useHistory } from 'react-router-dom';

import { usePackagingFlow } from '../../context/PackagingFlowContext';
import './QrReading.less';
import { usePalettes } from '../../queries/palette';
import { PackagingFlowDirection } from '../../queries/api/types';
const { Option } = Select;

const Qrparc: React.FC = React.memo(() => {
    const { user } = useAuth();
    const history = useHistory();

    const { reset, parcPalettes, setParcPalettes, selectedParc, setSelectedParc, setFlowType } = usePackagingFlow();
    const { data: palettesData } = usePalettes(user?.organization?.id || '');

    useEffect(() => {
        reset();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setFlowType(PackagingFlowDirection.ReturnToSupplier);
        setParcPalettes(palettesData || []);
        if (palettesData?.length === 1) {
            setSelectedParc(palettesData[0]);
            history.push('/qrReading', { from: 'qrParcs' });
        }
    }, [palettesData, setParcPalettes, setFlowType, setSelectedParc, history]);

    const handleSubmit = () => {
        if (selectedParc) {
            history.push('/qrReading', { from: 'qrParcs' });
        }
    };

    const handleParcChange = (value: string) => {
        const parc = parcPalettes.find((p) => p.name === value) || null;
        setSelectedParc(parc);
    };

    return (
        <div className="qr-reading-page">
            <div className="form-container">
                <div className="title">
                    <h2>Veuillez choisir un parc palettes</h2>
                </div>
                <Form layout="vertical" onFinish={handleSubmit}>
                    <Form.Item label="Parc palettes">
                        <Select
                            id="parcs"
                            placeholder="Choisir le parc palettes"
                            value={selectedParc?.name}
                            onChange={handleParcChange}
                            notFoundContent="Aucun résultat"
                            className="dropdown-input"
                        >
                            {parcPalettes.map((parc) => (
                                <Option key={parc.id} value={parc.name}>
                                    {parc.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <div className="back-button">
                            <Button type="primary" htmlType="submit">
                                Suivant
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
});

export default Qrparc;
